/**
 * Election Countdown Hooks
 * Shared across HomePage and state-specific pages.
 */
import { useState, useEffect, useCallback } from "react";

function makeCountdown(electionDate) {
  return function useCountdown() {
    const calc = useCallback(() => {
      const diff = electionDate - Date.now();
      const post = Date.now() - electionDate;
      if (diff > 0) return {
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        over: false,
      };
      if (post < 30 * 86400000) return { over: true, days: 0, hours: 0, minutes: 0 };
      return null;
    }, []);

    const [t, setT] = useState(calc);
    useEffect(() => {
      const id = setInterval(() => setT(calc()), 60000);
      return () => clearInterval(id);
    }, [calc]);
    return t;
  };
}

export const useSACountdown  = makeCountdown(new Date("2026-03-21T08:00:00+09:30"));
export const useVICCountdown = makeCountdown(new Date("2026-11-28T08:00:00+11:00"));
export const useNSWCountdown = makeCountdown(new Date("2027-03-27T08:00:00+11:00"));
